import { Notice, Skeleton } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

namespace SimplifiedApplicationMissingTermTypes {
  export interface Props {
    isClientTermAvailable: boolean;
    isClientTermLoading: boolean;
    isSimplifiedApplicationFlagMatched: boolean;
  }
}

export const SimplifiedApplicationMissingTerm: React.FC<
  SimplifiedApplicationMissingTermTypes.Props
> = ({ isClientTermAvailable, isClientTermLoading, isSimplifiedApplicationFlagMatched }) => {
  if (isClientTermAvailable || !isSimplifiedApplicationFlagMatched) {
    return null;
  }

  if (isClientTermLoading) {
    return <Skeleton height="inset.sm" flex={1} />;
  }

  return (
    <Notice
      backgroundColor={Utils.ColorToken.WithOpacity('feedback.attention.lightest', 0.4)}
      textObjects={[
        { text: 'Atenção: ', variant: 'bold' },
        {
          text: 'Esse cliente possui pendência de termo para operar esse produto.',
          variant: 'regular',
        },
      ]}
      type="warning"
    />
  );
};
